import {
  Select as RadixSelect,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../ui/select";
import { cn } from "../../lib/utils";

export type DashboardSelectOption = { value: string; label: string };

export type DashboardDataSelectProps = {
  value: string;
  onValueChange: (value: string) => void;
  options: DashboardSelectOption[];
  placeholder?: string;
  disabled?: boolean;
  /** Associates the trigger with an external `<label htmlFor>`. */
  triggerId?: string;
  triggerClassName?: string;
  contentClassName?: string;
};

const triggerBase =
  "w-full rounded-sm border-blue-100 bg-white font-normal text-gray-800 shadow-sm " +
  "hover:border-blue-200 focus-visible:border-blue-400 focus-visible:ring-[1px] focus-visible:ring-blue-400 " +
  "data-[placeholder]:text-gray-500 disabled:opacity-60";

const contentBase = "z-[1600] rounded-sm border-blue-100 bg-white shadow-md";

export function DashboardDataSelect({
  value,
  onValueChange,
  options,
  placeholder,
  disabled,
  triggerId,
  triggerClassName,
  contentClassName,
}: DashboardDataSelectProps) {
  return (
    <RadixSelect value={value} onValueChange={onValueChange} disabled={disabled}>
      <SelectTrigger
        id={triggerId}
        size="sm"
        className={cn(triggerBase, triggerClassName)}
      >
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent className={cn(contentBase, contentClassName)} position="popper">
        {options.map((opt) => (
          <SelectItem key={opt.value} value={opt.value} className="cursor-pointer rounded-sm text-sm">
            {opt.label}
          </SelectItem>
        ))}
      </SelectContent>
    </RadixSelect>
  );
}
